import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

const ERROR_TEXT = 'Unable to add the stand. Please try again.';

// Delegated so the button keeps working after the drawer is morphed by the Section Rendering API.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-lm-cart-addon]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  event.preventDefault();

  const errorMessage = button.closest('[data-lm-cart-upsell]')?.querySelector('.lm-cart-upsell__error');
  const variantId = button.dataset.lmCartAddon;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
    .filter(Boolean);

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (errorMessage) errorMessage.hidden = true;

  // Same event contract as product-form.js: cart-items-component morphs the drawer
  // with the returned sections, and the header cart bubble updates its count.
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(
      Theme.routes.cart_add_url,
      fetchConfig('json', {
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      })
    );
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || ERROR_TEXT);

    const cart = await (await fetch(`${Theme.routes.cart_url}.js`)).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'lm-cart-stand-upsell',
        itemCount: 1,
        sections: data.sections,
        didError: false,
      },
    });
  } catch (error) {
    const message = error instanceof Error && error.message ? error.message : ERROR_TEXT;
    deferred.reject(error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (errorMessage) {
      errorMessage.textContent = message;
      errorMessage.hidden = false;
    }
    button.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
  }
});
